// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HintNotion from '../components/HintNotion';
import { FormattedMessage } from 'react-intl';
import { ToggleButton } from '../../../components/Collapse';
import CollapseTransition from '../../../components/CollapseTransition';
import axios from 'axios';
import HintMarkdown from '../components/HintMarkdown';
import LoadingIcon from '../../../components/LoadingIcon';
import { useParamsId } from '../../../lib/utility';
import { recordHintCount } from '../../../apis/challenge';

const S = {
  HintContainer: styled.div`
    display: flex;
    flex-direction: column;
  `,
  H1Title: styled.div`
    display: flex;
    font-weight: 700;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    border-top: 2px solid #DEDEDE;
    padding-top: 43px;
    margin-top: 30px;
    margin-bottom: 10px;
  `,
  HintNotion: styled(HintNotion)`
    margin-left: 15.25px;
    width: 400px;
  `,
  HintFrame: styled.div<{ isCollapse?: boolean }>`
    margin-bottom: 20px;
    padding: 0 20px;
    ${props => (props.isCollapse) ? 'background: #FCE6CC;' : 'background: #EFEFEF;'};
    border-radius: 4px;
  `,
  HintTitleFrame: styled.div<{ isCollapse?: boolean }>`
  ${props => (props.isCollapse) ? null : 'transition-delay: 0.5s; transition-property: background-color;'};
  ${props => (props.isCollapse) ? null : 'border-bottom-right-radius: 4px; border-bottom-left-radius: 4px;'};
    display: flex;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    justify-content: space-between;
    height: 60px;
    align-items: center;
  `,
  HintContentFrame: styled.div`
    display: flex;
    background: #FCE6CC;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    flex-direction: column;
    overflow-x: auto;
  `,
  HintTitle: styled.div`
    display: flex;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #434343;
    height: 26px;
  `,
  UnlockButton: styled.div`
    display: flex;
    background: #EF8200;
    border-radius: 4px;
    cursor: pointer;
    width: 89px;
    height: 34px;
  `,
  ButtonFont: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    margin-left: 5.56px;
    width: 77.88px;
    justify-content: center;
  `,
  ToggleButton: styled(ToggleButton) <{ isCollapse?: boolean }>`
  ${props => {
      if (props.isCollapse) {
        return 'transition: all .5s; transform: rotate(0deg);'
      } else {
        return 'transition: all .5s; transform: rotate(180deg);'
      }
    }};
  `,
  HintContent: styled.div`
    display: flex;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    padding-bottom: 10px;
  `,
  IconFrame: styled.div`
    display: flex;
    justify-content: center;
  `
}

const parseMarkdown = (markdown: string): string[] => {
  const parsed:string[] = markdown
    .split('\n## ')
    .slice(1)
    .map(s => '## ' + s)
    .map(s => s.trim())
    .reduce((fin:string[], cur:string):string[] => {
      if (fin.length > 0) {
        const last = fin.pop() || '';
        if ((last.match(/```/g) || []).length % 2 === 1) {
          return fin.concat(last.concat(cur));
        } else {
          fin.push(last);
          return fin.concat(cur);
        }
      } else {
        return fin.concat(cur);
      }
    }, [])
  return (parsed);
}

const HintContent = (props: any): JSX.Element => {
  const hintName = props.hintName;
  const hintPath = props.hintPath;
  const challenge = props.challenge;
  const baseUrl = challenge.runningInfo.markdownUrl;
  const imgUrl= `${challenge.runningInfo.markdownUrl}/${hintPath}`;
  const id = useParamsId();
  const [hintMarkdowns, setHintMarkdowns] = useState<string[]>([]);
  const [isUnlock, setUnlock] = useState(() => {
    const status = localStorage.getItem(hintPath);
    if (status && status == 'true') {
      return (true);
    } else {
      return (false);
    }
  });
  const [isCollapse, setCollapse] = useState(false);
  const [isFetchingHint, setIsFetchingHint] = useState(false);

  const getHintContent = () => {
    const mdPath = `${hintPath}/README.md`;
    if (challenge?.runningInfo?.markdownUrl) {
      const url = `${challenge.runningInfo.markdownUrl}/${mdPath}`
      axios.get(url, { withCredentials: true })
        .then((result) => {
          const markdown: string = result.data;
          const parsed:string[] = parseMarkdown(markdown)
          setHintMarkdowns(parsed);
          setIsFetchingHint(false);
          if (!isUnlock) {
            handleRecordHintOpenCount(id);
          }
        })
        .catch(() => {
          setHintMarkdowns([])
        });
    } else {
      setHintMarkdowns([]);
    }
    return [hintMarkdowns];
  }

  const handleCollapse = (isCollapse: boolean) => {
    if (!isCollapse) {
      getHintContent();
    }
    setCollapse(!isCollapse);
  }

  const handleHintContent = () => {
    setIsFetchingHint(true);
    setUnlock(true);
    getHintContent();
    setCollapse(!isCollapse);
    localStorage.setItem(hintPath, 'true');
  }

  const handleRecordHintOpenCount = (id: number) => {
    recordHintCount(id)
      .then((result: any) => {
        console.log('You open ', result.data, ' hints');
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  if (isUnlock) {
    return (
      <S.HintFrame isCollapse={isCollapse}>
        <S.HintTitleFrame key={hintPath} isCollapse={isCollapse}>
          <S.HintTitle>
            {hintName}
          </S.HintTitle>
          <S.ToggleButton onClick={() => handleCollapse(isCollapse)} isOpen={isUnlock} isCollapse={isCollapse}/>
        </S.HintTitleFrame>
        <CollapseTransition visible={isCollapse}>
          <S.HintContentFrame>
            <S.IconFrame>
              {isFetchingHint && <LoadingIcon size={10} />}
            </S.IconFrame>
            <S.HintContent>
              <HintMarkdown baseUrl={baseUrl} imgUrl={imgUrl} markdowns={hintMarkdowns}/>
            </S.HintContent>
          </S.HintContentFrame>
        </CollapseTransition>
      </S.HintFrame>
    )
  } else {
    return (
      <S.HintFrame isCollapse={isCollapse}>
        <S.HintTitleFrame key={hintPath} isCollapse={isCollapse}>
          <S.HintTitle>
            {hintName}
          </S.HintTitle>
          <S.UnlockButton onClick={() => handleHintContent()}>
            <S.ButtonFont>
              <FormattedMessage id="E058" />
            </S.ButtonFont>
          </S.UnlockButton>
        </S.HintTitleFrame>
      </S.HintFrame>
    )
  }
}

// const hintLists = [
//   {'Name': 'Hint 1 : Active the Datasync Agent', 'Content': 'The website was working properly with the older version'},
//   {'Name': 'Hint 2 : Get the IP address', 'Content': 'Get the IP address xxx xxx xxx xxx xxx xxx xxx xxx xxx'},
//   {'Name': 'Hint 3 : Get the resource', 'Content': 'Get the resource ooo ooo ooo ooo ooo ooo ooo ooo ooo ooo ooo ooo ooo ooo'}
// ]

const Hint = (props: any): JSX.Element => {
  const isChallengeStart = props.isChallengeStart;
  const challenge = props.challenge;
  const currentTask = localStorage.getItem('lastFocus');
  const navigationList = localStorage.getItem('navigationList');
  let hints: never[] = [];

  const getTaskHints = () => {
    if (navigationList) {
      JSON.parse(navigationList).forEach(function(item: any, i: any) {
        if (Object.values(item).includes(currentTask)) {
          hints = item.hints;
        }
      })
    } else {
      console.log('Cannot found naviagationList');
    }
  };

  const [hintList, setHintLists] = useState(() => {
    getTaskHints();
    return (hints);
  });

  useEffect(() => {
    getTaskHints();
  }, [currentTask]);

  const HintContents = hintList.map((item: any) => {
    return (
      <HintContent key={item.path} challenge={challenge} isChallengeStart={isChallengeStart} hintPath={item.path} hintName={item.title}></HintContent>
    )
  })
  return (
    <>
      {hintList.length>0 && <S.HintContainer>
        <S.H1Title>
          <FormattedMessage id="E057" />
          <S.HintNotion />
        </S.H1Title>
        {HintContents}
      </S.HintContainer>}
    </>
  )
}

export default Hint;
